export default "__VITE_ASSET__DudeZuf___"